"use strict";

/**
 * Collecting stats for the fatigue
 */
;
(function () {
  document.addEventListener('flix:load', onPageLoad);
  var _viewPercentage = 20,
    _statData = new Map(),
    _videoList = [],
    // Keys already handed to a request. A second hide/unload must not send them again.
    _inflightToken = new Map();
  var initialized = false;
  var pageInfo;
  function getEndpoint() {
    return Flix.env == 'production' ? 'https://ac2.tnaflix.com/stats.php' : '/local/fatigue';
  }

  // function getEndpoint() {
  //    return 'https://ac2.tnaflix.com/stats.php'
  // }

  /**
   * Main logic
   */
  function onPageLoad() {
    if (isMSIE() || FlixUtils.isCrawler() || !Flix.isTna()) {
      return;
    }
    _statData = new Map();
    _inflightToken = new Map();
    _videoList = [];
    init();
    pageInfo = JSON.parse(document.querySelector('#page-info').textContent);
    checkVisibility();
    document.querySelectorAll('.video-list div[data-vid]').forEach(function (element) {
      if (element.getAttribute('data-vid')) {
        _videoList.push(element.getAttribute('data-vid'));
      }
      element.addEventListener('click', function (e) {
        logEvent(e.currentTarget.getAttribute('data-vid'), 'thumb_click', e.currentTarget.getAttribute('data-first-thumb'), e.currentTarget.getAttribute('data-num'));
      });
    });

    //itial page view event
    if (_getPageInternalInfo().pageInternal == 'search') {
      var _document$querySelect, _document$querySelect2, _document$querySelect3, _document$querySelect4;
      var _fixedSearch = (_document$querySelect = (_document$querySelect2 = document.querySelector('#fixedSearch')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.value) !== null && _document$querySelect !== void 0 ? _document$querySelect : '';
      var _found = parseInt((_document$querySelect3 = (_document$querySelect4 = document.querySelector('#isFoundInCache')) === null || _document$querySelect4 === void 0 ? void 0 : _document$querySelect4.value) !== null && _document$querySelect3 !== void 0 ? _document$querySelect3 : 0);
      _statData.set("search", {
        event: 'search',
        search_original: _getPageInternalInfo().pageInternalData,
        search_fixed: _fixedSearch,
        record_found_in_cache: _found,
        stamp: new Date().getTime(),
        search_source: _getSearchSource()
      });
    }
    logEvent(0, 'page_view', 0, 0);
  }

  /**
   * Set initial event listeners
   */
  function init() {
    if (initialized) {
      return;
    }
    initialized = true;
    var sive = false;
    try {
      var opts = Object.defineProperty({}, 'ive', {
        get: function get() {
          sive = true;
        }
      });
      window.addEventListener("testive", null, opts);
      window.removeEventListener("testive", null, opts);
    } catch (e) {}

    //document.addEventListener('DOMContentLoaded', this.checkVisibility);
    document.addEventListener('load', checkVisibility);
    window.addEventListener('scroll', checkVisibility, sive ? {
      ive: true
    } : false);
    document.addEventListener('containerElementChanged', checkVisibility);
    //window.addEventListener("visibilitychange", this.logData);

    window.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        logData();
      } else {
        checkVisibility();
      }
    });
    window.addEventListener('pagehide', logData);
    window.addEventListener('beforeunload', logData);
    document.addEventListener('fatigueLogEvent', function (e) {
      logEvent(e.detail.VID, e.detail.eventType, e.detail.thumbIndex, e.detail.thumbPosition);
    });
    document.querySelectorAll('.badge, .badge-video > a').forEach(function (el) {
      el.addEventListener('click', function () {
        if (storageAvailable('localStorage')) {
          localStorage.setItem('search_source', 'tag');
        }
      });
    });
  }

  /**
   * Add data to stats collector on page close.
   * Each event is sent once. A later hide or unload skips anything already in flight,
   * and the buffer drops those keys only after the request succeeds.
   */
  var _sendToken = 0;
  function logData() {
    if (isMSIE() || isCrawler()) {
      return;
    }
    var UID = -1;
    var token = ++_sendToken;
    var batch = _statData;
    var keys = [];
    var res = [];
    batch.forEach(function (val, key) {
      if (_inflightToken.has(key)) {
        return;
      }
      var copy = Object.assign({}, val);
      if (Object.prototype.hasOwnProperty.call(copy, 'duration') && copy.duration === 0 && copy.start) {
        copy.duration = Date.now() - copy.start;
        delete copy.start;
      }
      keys.push(key);
      res.push(copy);
    });
    if (res.length === 0) {
      return;
    }
    keys.forEach(function (key) {
      _inflightToken.set(key, token);
    });
    var data = JSON.stringify({
      uid: UID,
      platform: 'mobile',
      events: res,
      statsUID: _getStatsUid(),
      stats_cross_id: FlixUtils.stats.getCrossId(),
      tab_id: FlixUtils.stats.getTabId(),
      refInternal: _getInternalRefPageInfo().pageInfo,
      refInternalData: _getInternalRefPageInfo().pageData,
      pageInternal: _getPageInternalInfo().pageInternal,
      pageInternalData: _getPageInternalInfo().pageInternalData,
      refDomain: _getRefDomain(),
      campaign: _getUtmCampaign(),
      searchGroup: _getTestGroupId()
    });
    postEvents(data, function (ok) {
      keys.forEach(function (key) {
        if (_inflightToken.get(key) === token) {
          _inflightToken["delete"](key);
        }
      });
      if (!ok || batch !== _statData) {
        return;
      }
      keys.forEach(function (key) {
        batch["delete"](key);
      });
      if (document.visibilityState === 'visible') {
        checkVisibility();
      }
    });
  }
  function postEvents(data, onDone) {
    var finished = false;
    function payload() {
      var fd = new FormData();
      fd.append('data', data);
      return fd;
    }
    function finish(ok) {
      if (finished) {
        return;
      }
      finished = true;
      onDone(ok);
    }
    if (typeof fetch === 'function') {
      try {
        fetch(getEndpoint(), {
          method: 'POST',
          body: payload(),
          keepalive: true
        }).then(function (response) {
          finish(response.ok);
        })["catch"](function () {
          finish(false);
        });
        return;
      } catch (e) {}
    }
    if (typeof navigator.sendBeacon === 'function' && navigator.sendBeacon(getEndpoint(), payload())) {
      finish(true);
      return;
    }
    try {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', getEndpoint(), true);
      xhr.onload = function () {
        finish(xhr.status >= 200 && xhr.status < 300);
      };
      xhr.onerror = function () {
        finish(false);
      };
      xhr.send(payload());
    } catch (e) {
      finish(false);
    }
  }
  function checkVisibility() {
    //find all videos on page, check if they're in the viewport, log those that are in
    document.querySelectorAll('.video-list div[data-vid]').forEach(function (element) {
      if (element.getAttribute('data-vid')) {
        if (elementAtViewport(element, _viewPercentage)) {
          //we should actually log thumb view start stamp
          //if hidden (due to scroll, preview or click) - stop timer
          if (!_statData.has('thumb_view' + "-" + element.getAttribute('data-vid'))) {
            logEvent(element.getAttribute('data-vid'), 'thumb_view', element.getAttribute('data-first-thumb'), element.getAttribute('data-num'));
          }
        } else {
          //we should terminate view events here
          var thumbKey = 'thumb_view-' + element.getAttribute('data-vid');
          if (_statData.has(thumbKey) && !_inflightToken.has(thumbKey)) {
            var obj = _statData.get(thumbKey);
            if (obj.duration === 0) {
              obj.duration = Date.now() - obj.start;
              delete obj.start;
              _statData.set('event-' + Date.now().toString() + Math.floor(Math.random() * 10000), obj);
              _statData["delete"](thumbKey);
            }
          }
        }
      }
    });
  }

  //add event to stack
  function logEvent(vid, eventType, thumbIndex, thumbPosition) {
    var _pageInfo$routeArgs$p;
    if (isMSIE()) {
      return;
    }
    var BASE_POS = (((_pageInfo$routeArgs$p = pageInfo['routeArgs']['page']) !== null && _pageInfo$routeArgs$p !== void 0 ? _pageInfo$routeArgs$p : 1) - 1) * 60;
    if (!BASE_POS) {
      var _searchParams$get;
      var searchParams = new URLSearchParams(window.location.search);
      BASE_POS = (((_searchParams$get = searchParams.get('page')) !== null && _searchParams$get !== void 0 ? _searchParams$get : 1) - 1) * 60;
    }
    if (!isNaN(parseInt(BASE_POS))) {
      thumbPosition = parseInt(thumbPosition) + parseInt(BASE_POS);
    }
    var foundCurrent = false;
    switch (eventType) {
      case 'thumb_view':
        if (_inflightToken.has(eventType + "-" + vid)) {
          break;
        }
        if (_statData.has(eventType + "-" + vid)) {
          //stop
          var obj = _statData.get(eventType + "-" + vid);
          if (obj.duration === 0) {
            obj.duration = Date.now() - obj.start;
            delete obj.start;
            _statData.set('event-' + Date.now().toString() + Math.floor(Math.random() * 10000), obj);
            _statData["delete"](eventType + "-" + vid);
          }
        } else {
          //start
          _statData.set(eventType + "-" + vid, {
            vid: vid,
            event: eventType,
            thumbIndex: thumbIndex,
            thumbPosition: thumbPosition,
            start: Date.now(),
            duration: 0,
            stamp: new Date().getTime()
          });
        }
        break;
      case 'trailer_view':
        logEvent(vid, 'thumb_view', thumbIndex, thumbPosition);
        if (_inflightToken.has(eventType + "-" + vid)) {
          break;
        }
        if (_statData.has(eventType + "-" + vid)) {
          //stop
          var _obj = _statData.get(eventType + "-" + vid);
          _obj.duration = Date.now() - _obj.start;
          delete _obj.start;
          _statData.set('event-' + Date.now().toString() + Math.floor(Math.random() * 10000), _obj);
          _statData["delete"](eventType + "-" + vid);
        } else {
          //start
          _statData.set(eventType + "-" + vid, {
            vid: vid,
            event: eventType,
            thumbIndex: thumbIndex,
            thumbPosition: thumbPosition,
            start: Date.now(),
            duration: 0,
            stamp: new Date().getTime()
          });

          //must have a thumb view for this and all before
          document.querySelectorAll('.video-list div[data-vid]').forEach(function (element) {
            if (element.getAttribute('data-vid')) {
              if (!foundCurrent) {
                logEvent(element.getAttribute('data-vid'), 'thumb_view', element.getAttribute('data-first-thumb'), element.getAttribute('data-num'));
              }
              if (element.getAttribute('data-vid') == vid) {
                foundCurrent = true;
              }
            }
          });
        }
        break;
      case 'thumb_click':
        logEvent(vid, 'trailer_view', thumbIndex, thumbPosition);

        //must have a thumb view for this and all before
        document.querySelectorAll('.video-list div[data-vid]').forEach(function (element) {
          if (element.getAttribute('data-vid')) {
            if (!foundCurrent) {
              logEvent(element.getAttribute('data-vid'), 'thumb_view', element.getAttribute('data-first-thumb'), element.getAttribute('data-num'));
            }
            if (element.getAttribute('data-vid') == vid) {
              foundCurrent = true;
            }
          }
        });
        _statData.set(eventType + "-" + vid, {
          vid: vid,
          event: eventType,
          thumbIndex: thumbIndex,
          thumbPosition: thumbPosition,
          stamp: new Date().getTime()
        });
        break;
      default:
        _statData.set(eventType + "-" + vid, {
          vid: vid,
          event: eventType,
          thumbIndex: thumbIndex,
          thumbPosition: thumbPosition,
          stamp: new Date().getTime()
        });
        break;
    }
  }
  function elementAtViewport(el) {
    var check = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
    if (el.getClientRects().length === 0) {
      return false;
    }

    // special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
      el = el[0];
    }
    var rect = el.getBoundingClientRect();
    var visible = false;

    // Checking if the element is actually visible
    if (getComputedStyle(el).display !== 'none' && getComputedStyle(el).visibility !== 'hidden') {
      // Only top of the rect is to be checked
      if (check === 'top') {
        visible = rect.top <= (window.innerHeight || document.documentElement.clientHeight);
      } else if (check === 'full') {
        // Element is fully visible
        visible = rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
      } else if (typeof parseInt(check) === 'number') {
        // Percent of the element's visibility
        var windowHeight = window.innerHeight || document.documentElement.clientHeight;
        windowHeight = windowHeight / 2; //work only with top 50% of the screen
        var windowWidth = window.innerWidth || document.documentElement.clientWidth;
        if (rect.top < 0 && rect.bottom < 0 || rect.top > windowHeight && rect.bottom > windowHeight || rect.left < 0 && rect.right < 0 || rect.left > windowWidth && rect.right > windowWidth) {
          return false;
        }
        var visibleHeight = 0;
        if (rect.top < 0) {
          if (rect.bottom > windowHeight) {
            visibleHeight = windowHeight;
          } else {
            visibleHeight = rect.bottom;
          }
        } else {
          if (rect.bottom > windowHeight) {
            visibleHeight = windowHeight - rect.top;
          } else {
            visibleHeight = rect.bottom - rect.top;
          }
        }
        var visibleWidth = 0;
        if (rect.left < 0) {
          if (rect.right > windowWidth) {
            visibleWidth = windowWidth;
          } else {
            visibleWidth = rect.right;
          }
        } else {
          if (rect.right > windowWidth) {
            visibleWidth = windowWidth - rect.left;
          } else {
            visibleWidth = rect.right - rect.left;
          }
        }
        var SFull = rect.width * rect.height;
        var SVisible = visibleHeight * visibleWidth;
        visible = SVisible > SFull * parseInt(check) / 100;
      }
    }
    return visible;
  }
  function isMSIE() {
    return window.navigator.Agent.indexOf("MSIE ") > 0 || !!navigator.Agent.match(/Trident.*rv\:11\./);
  }
  function isCrawler() {
    return /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.Agent);
  }
  function storageAvailable(type) {
    var storage;
    try {
      storage = window[type];
      var x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return e instanceof DOMException && (e.code === 22 || e.code === 1014 || e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && storage && storage.length !== 0;
    }
  }
  function _getRefDomain() {
    if (window.referrer_fallback) {
      var _ref = new URL(window.referrer_fallback);
      if (_ref.host != window.location.host) {
        FlixUtils.setCookie('_ard', _ref.host, 365);
        return _ref.host;
      }
    } else if (FlixUtils.hasCookie('_ard')) {
      return FlixUtils.getCookie('_ard');
    } else {
      return '';
    }
  }
  function _getUtmCampaign() {
    var searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('utm_campaign')) {
      FlixUtils.setCookie('_autmc', searchParams.get('utm_campaign'), 365);
      return searchParams.get('utm_campaign');
    } else if (FlixUtils.hasCookie('_autmc')) {
      return FlixUtils.getCookie('_autmc');
    } else {
      return '';
    }
  }
  function _getStatsUid() {
    if (FlixUtils.hasCookie('_auid')) {
      return FlixUtils.getCookie('_auid');
    } else {
      var _id = Math.random().toString().slice(2, 16);
      FlixUtils.setCookie('_auid', _id, 365);
      return _id;
    }
  }
  function _getInternalRefPageInfo() {
    var pageInfo = '';
    var pageData = '';
    if (window.referrer_fallback) {
      var _ref = new URL(window.referrer_fallback);
      if (_ref.host == window.location.host) {
        if (_ref.pathname.indexOf('/search.php') != -1) {
          pageInfo = 'search';
          var searchParams = new URLSearchParams(window.referrer_fallback);
          pageData = searchParams.get('what');
        } else if (_ref.pathname.indexOf('/video') != -1) {
          pageInfo = 'video';
          pageData = _ref.pathname.match(/\/video(\d+)/)[1];
        } else if (_ref.pathname == '') {
          pageInfo = 'index';
        }
      }
    }
    return {
      pageInfo: pageInfo,
      pageData: pageData
    };
  }
  function _getPageInternalInfo() {
    var pageInternal = '';
    var pageInternalData = '';
    var searchParams = new URLSearchParams(window.location.search);
    switch (pageInfo['currentRouteId']) {
      case 'controllers.video.view':
        pageInternal = 'video';
        pageInternalData = pageInfo['routeArgs']['vid'];
        break;
      case 'controllers.video.home':
        pageInternal = 'index';
        break;
      case 'controllers.video.category':
        pageInternal = 'category';
        pageInternalData = pageInfo['routeArgs']['categorySlug'];
        break;
      case 'controllers.video.search':
        pageInternal = 'search';
        pageInternalData = searchParams.get('what');
        break;
      case 'controllers.channel.index':
        pageInternal = 'channels';
        break;
      case 'controllers.channel.view':
        pageInternal = 'channel';
        pageInternalData = pageInfo['routeArgs']['slug'];
        break;
      case 'controllers.profile.pornstars':
        pageInternal = 'pornstars';
        break;
      case 'controllers.profile.view':
        pageInternal = 'profile';
        pageInternalData = pageInfo['routeArgs']['name'];
        break;
    }
    return {
      pageInternal: pageInternal,
      pageInternalData: pageInternalData
    };
  }
  function _getTestGroupId() {
    if (FlixUtils.hasCookie('scgi')) {
      return FlixUtils.getCookie('scgi');
    } else {
      var tgid = _getRandomInt(1, 4);
      FlixUtils.setCookie('scgi', tgid, 365);
      return tgid;
    }
  }
  function _getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  function _getSearchSource() {
    if (storageAvailable('localStorage')) {
      if (localStorage.getItem('search_source')) {
        return localStorage.getItem('search_source');
      }
    }
    return '';
  }
})();